import { enUS } from '@mui/x-date-pickers/locales';
import { enUS as DateFnsLocale } from 'date-fns/locale/en-US';
import type { Locales } from '@hub/common';

import type { Locale } from 'date-fns';

export type DateLocales = {
  mui: typeof enUS;
  dateFns: Locale;
};

export const getDateLocales = async (locale: Locales): Promise<DateLocales> => {
  switch (locale) {
    // case 'eu':
    //   return {
    //     mui: (await import('@mui/x-date-pickers/locales/eu')).eu,
    //     dateFns: (await import('date-fns/locale/eu')).eu,
    //   };
    // case 'be-BY':
    //   return {
    //     mui: (await import('@mui/x-date-pickers/locales/beBY')).beBY,
    //     dateFns: (await import('date-fns/locale/be')).be,
    //   };
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/caES')).caES,
    //   dateFns: (await import('date-fns/locale/ca')).ca,
    // };
    // case 'zh-HK':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/zhHK')).zhHK,
    //   dateFns: (await import('date-fns/locale/zh-HK')).zhHK,
    // };
    // case 'zh-CN':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/zhCN')).zhCN,
    //   dateFns: (await import('date-fns/locale/zh-CN')).zhCN,
    // };
    // case 'cs-CZ':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/csCZ')).csCZ,
    //   dateFns: (await import('date-fns/locale/cs')).cs,
    // };
    // case 'da-DK':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/daDK')).daDK,
    //   dateFns: (await import('date-fns/locale/da')).da,
    // };
    case 'nl-NL':
      return {
        mui: (await import('@mui/x-date-pickers/locales')).nlNL,
        dateFns: (await import('date-fns/locale/nl')).nl,
      };
    // case 'fi-FI':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/fiFI')).fiFI,
    //   dateFns: (await import('date-fns/locale/fi')).fi,
    // };
    case 'fr-FR':
      return {
        mui: (await import('@mui/x-date-pickers/locales')).frFR,
        dateFns: (await import('date-fns/locale/fr')).fr,
      };
    // case 'de-DE':
    //   return {
    //     mui: (await import('@mui/x-date-pickers/locales/deDE')).deDE,
    //     dateFns: (await import('date-fns/locale/de')).de,
    //   };
    // case 'el-GR':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/elGR')).elGR,
    //   dateFns: (await import('date-fns/locale/el')).el,
    // };
    // case 'he-IL':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/heIL')).heIL,
    //   dateFns: (await import('date-fns/locale/he')).he,
    // };
    // case 'hu-HU':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/huHU')).huHU,
    //   dateFns: (await import('date-fns/locale/hu')).hu,
    // };
    // case 'is-IS':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/isIS')).isIS,
    //   dateFns: (await import('date-fns/locale/is')).is,
    // };
    // case 'it-IT':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/itIT')).itIT,
    //   dateFns: (await import('date-fns/locale/it')).it,
    // };
    // case 'ja-JP':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/jaJP')).jaJP,
    //   dateFns: (await import('date-fns/locale/ja')).ja,
    // };
    // case 'kz-KZ':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/kzKZ')).kzKZ,
    //   dateFns: (await import('date-fns/locale/kk')).kk,
    // };
    // case 'ko-KR':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/koKR')).koKR,
    //   dateFns: (await import('date-fns/locale/ko')).ko,
    // };
    // case 'mk':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/mk')).mk,
    //   dateFns: (await import('date-fns/locale/mk')).mk,
    // };
    // case 'nb-NO':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/nbNO')).nbNO,
    //   dateFns: (await import('date-fns/locale/nb')).nb,
    // };
    // case 'fa-IR':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/faIR')).faIR,
    //   dateFns: (await import('date-fns/locale/fa-IR')).faIR,
    // };
    // case 'pl-PL':
    //   return {
    //     mui: (await import('@mui/x-date-pickers/locales/plPL')).plPL,
    //     dateFns: (await import('date-fns/locale/pl')).pl,
    //   };
    // case 'pt-BR':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/ptBR')).ptBR,
    //   dateFns: (await import('date-fns/locale/pt-BR')).ptBR,
    // };
    // case 'ro-RO':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/roRO')).roRO,
    //   dateFns: (await import('date-fns/locale/ro')).ro,
    // };
    // case 'ru-RU':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/ruRU')).ruRU,
    //   dateFns: (await import('date-fns/locale/ru')).ru,
    // };
    // case 'sk-SK':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/skSK')).skSK,
    //   dateFns: (await import('date-fns/locale/sk')).sk,
    // };
    // case 'es-ES':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/esES')).esES,
    //   dateFns: (await import('date-fns/locale/es')).es,
    // };
    // case 'sv-SE':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/svSE')).svSE,
    //   dateFns: (await import('date-fns/locale/sv')).sv,
    // };
    // case 'tr-TR':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/trTR')).trTR,
    //   dateFns: (await import('date-fns/locale/tr')).tr,
    // };
    // case 'uk-UA':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/ukUA')).ukUA,
    //   dateFns: (await import('date-fns/locale/uk')).uk,
    // };
    // case 'vi-VN':
    // return {
    //   mui: (await import('@mui/x-date-pickers/locales/viVN')).viVN,
    //   dateFns: (await import('date-fns/locale/vi')).vi,
    // };
    case 'de-DE':
    case 'pl-PL':
    case 'be-BY':
    case 'zh-HK':
    case 'zh-CN':
    case 'cs-CZ':
    case 'da-DK':
    case 'fi-FI':
    case 'ca-ES':
    case 'el-GR':
    case 'he-IL':
    case 'hu-HU':
    case 'is-IS':
    case 'it-IT':
    case 'ja-JP':
    case 'kz-KZ':
    case 'ko-KR':
    case 'mk':
    case 'nb-NO':
    case 'fa-IR':
    case 'pt-BR':
    case 'ro-RO':
    case 'ru-RU':
    case 'sk-SK':
    case 'es-ES':
    case 'uk-UA':
    case 'sv-SE':
    case 'tr-TR':
    case 'vi-VN':
    case 'en-US':
    case 'eu':
      // English US
      return {
        mui: enUS,
        dateFns: DateFnsLocale,
      };
    default:
      // this should never happen but just in case we return English US
      locale satisfies never;
      // English US
      return getDefaultLocale();
  }
};

export const getDefaultLocale = (): DateLocales => ({
  mui: enUS,
  dateFns: DateFnsLocale,
});
